





































import { Component, Vue, Ref, Prop } from "vue-property-decorator";
import ConfirmationDialogComponent from "@/components/common/ConfirmationDialog.vue";
import BaseDialogComponent from "@/components/common/BaseDialog.vue";
import {
  RoleSettings,
  getRoleLabelForRoleSettings,
} from "@/data/models/RoleSettings";
import { saveRoleSettings } from "@/data/repository/RoleSettingsRepository";
import { Role } from "@/data/models/User";

@Component({
  components: {
    "base-dialog": BaseDialogComponent,
    "confirmation-dialog": ConfirmationDialogComponent,
  },
})
export default class RoleFormComponent extends Vue {
  @Ref("baseDialog")
  baseDialogComponent!: BaseDialogComponent;

  @Ref("confirm")
  confirmationDialogComponente!: ConfirmationDialogComponent;

  @Prop() role!: Role;
  @Prop() roleSettings!: RoleSettings;
  @Prop() countedUser!: number;

  showingSuccessSnackbar = false;
  successSnackbarText = "";

  isLoading = false;

  label = "";
  description = "";
  roleActive = false;

  initialLabel = "";
  initialDescription = "";
  initialRoleActive = false;

  selectedRoleSetting: RoleSettings[] = [];

  roleLabelError: Array<string> = [];
  roleActiveError: Array<string> = [];

  resolve?: (value: boolean) => void = undefined;
  reject?: (reason: string) => void = undefined;

  get roleLabelInputLabel() {
    return this.withMandatoryMarker(
      this.$t("users.role.label").toString(),
      true
    );
  }

  /** Appends a required marker to a label when the field is mandatory. */
  withMandatoryMarker(label: string, isMandatory: boolean) {
    return isMandatory ? `${label} *` : label;
  }

  async show(label: string, description: string, roleActive: boolean) {
    this.label = label;
    this.description = description;
    this.roleActive = roleActive;

    this.initialRoleActive = this.roleActive;
    this.initialLabel = this.label;
    this.initialDescription = this.description;

    this.roleLabelError = [];
    this.roleActiveError = [];

    this.baseDialogComponent.show({
      title: this.$t("settings.roleManagement.editRole").toString(),
      positiveButtonText: this.$t("common.save").toString(),
      negativeButtonText: this.$t("common.abort").toString(),
      closeOnSave: false,
      closeOnNeutralAction: false,
      maxWidth: 800,
    });

    return new Promise<boolean>((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }

  //Function to save changes on RoleDialog
  async onSave() {
    let isInputValid = true;
    this.isLoading = true;

    //check label
    Object.values(Role).forEach((role) => {
      if (
        this.role !== role &&
        getRoleLabelForRoleSettings(this.roleSettings, role, this) ===
          this.label
      ) {
        this.roleLabelError = [
          this.$t("settings.roleManagement.error.wrongLabel").toString(),
        ];
        isInputValid = false;
      }
      if ( this.label === "") {
        this.roleLabelError = [
          this.$t("settings.roleManagement.error.wrongLabel").toString(),
        ];
        isInputValid = false;
      }
    });

    //check roleActive
    if (
      this.roleActive == false &&
      this.roleActive !== this.initialRoleActive &&
      this.countedUser !== 0
    ) {
      this.roleActiveError = [
          this.$t("settings.roleManagement.error.activeUserForRole").toString(),];
      isInputValid = false;
    }

    //check isInputValid
    if (!isInputValid) {
      this.isLoading = false;
      return;
    }

    const roleSettingsUpdate = this.roleSettings;
    const roleConfiguration = roleSettingsUpdate.roleToConfiguration[this.role];

    roleConfiguration.label = this.label;
    roleConfiguration.description = this.description;
    roleConfiguration.roleActive = this.roleActive;
    roleConfiguration.capabilityMap

    //save
    if (isInputValid) {
      await saveRoleSettings(roleSettingsUpdate, false);
      this.showingSuccessSnackbar = true;
      this.successSnackbarText = this.$t("common.changesSaved").toString();
      this.baseDialogComponent.isShowing = false;
    }

    this.isLoading = false;
  }
}
